import { render, staticRenderFns } from "./Miembros.vue?vue&type=template&id=2f3e2889"
import script from "./Miembros.vue?vue&type=script&lang=js"
export * from "./Miembros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports